import React from "react"

import Transition from "./Transition"
import CookieConsent from "./CookieConsent/CookieConsent"

const Layout = ({ children, location }) => (
  <>
    <Transition location={location}>{children}</Transition>
    <CookieConsent />
  </>
)

export default Layout
